import { Button } from '@/components/ui/button';
import { useTrackEvent } from '@/hooks/useTrackEvent';

interface WhatsAppCTAProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  size?: 'default' | 'sm' | 'lg' | 'icon';
  source?: string;
}

const WhatsAppCTA = ({ href, children, className, size = 'lg', source = 'cta' }: WhatsAppCTAProps) => {
  const { trackEventBeforeNavigation } = useTrackEvent();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    trackEventBeforeNavigation('whatsapp_click', { source }, href);
  };

  return (
    <Button
      asChild
      size={size}
      className={className || 'bg-primary hover:bg-primary/90 text-lg px-8 py-6 h-auto'}
    >
      <a 
        href={href} 
        target="_blank" 
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        {children}
      </a>
    </Button>
  );
};

export default WhatsAppCTA;
